import { MapViewState }               from '@tokamap/core';
import { FRAMING_REFERENCE_VIEWPORT } from '@tokamap/core';
import currentEditorStore             from '@/TokamapEditor/stores/currentEditorStore';

export default function framedLegacyView(view: MapViewState): MapViewState {
	const adapter = currentEditorStore.get?.mapAdapter;

	if (!adapter?.getFraming()) return view;

	const camera = adapter.getStartCamera(FRAMING_REFERENCE_VIEWPORT);
	const geometry = adapter.getFramingGeometry();
	const origin = currentEditorStore.documentOrigin;

	return {
		center: camera?.center ?? origin?.center ?? view.center,
		zoom: camera?.zoom ?? origin?.zoom ?? view.zoom,
		rotationDeg: camera?.rotationDeg ?? view.rotationDeg,
		zoomMin: geometry?.minZoom ?? 0,
		zoomMax: geometry?.maxZoom ?? view.zoomMax,
	};
}
